"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = Icon;
exports.normalizeIconName = normalizeIconName;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _icon = require("@site/icons/registry/icon");
/* eslint-disable max-len */
const MediaPlayer = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: 'media-player-icon',
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "32",
    height: "32",
    rx: "16",
    fill: "#111111"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3111 15.5866L13.2656 12.0834C13.0866 12 12.9143 11.9791 12.7486 12.0209C12.5829 12.0626 12.5 12.2383 12.5 12.5481V19.4473C12.5 19.7333 12.5878 19.906 12.7635 19.9656C12.9392 20.0252 13.1065 20.0073 13.2656 19.912L19.3111 16.4088C19.437 16.2956 19.5 16.1586 19.5 15.9977C19.5 15.8368 19.437 15.6998 19.3111 15.5866Z",
    fill: "white"
  }));
};
/* eslint-enable max-len */

const iconMap = {
  'media-player': /*#__PURE__*/_react.default.createElement(MediaPlayer, null)
};

/**
 * Gets the UX Icon by name
 * See list of icon names available for MOPs to use:
 *    /sitecore/content/Global/GoDaddy/Settings/Icons
 * @param {string} name the icon name
 * @returns {React.ReactElement} the UX Core Icon as a React element or component
 */
function Icon({
  name,
  className,
  style,
  ...props
}) {
  const normalizedName = normalizeIconName(name);
  let IconElement = iconMap[normalizedName];
  if (IconElement) return IconElement;
  IconElement = /*#__PURE__*/_react.default.createElement(_icon.Icon, (0, _extends2.default)({
    name: normalizedName,
    className: className,
    style: style
  }, props));
  return IconElement;
}

/**
 * Overtime UXCore will add or remove or simply rename icons.
 * See:
 *   https://uxcore.uxp.gdcorp.tools/docs/help/upgrade-guides/2102#new-uxicon-icons-renames-and-deprecations
 * @param {string} name the icon name
 * @returns {string} the latest icon name, if not found, returns name passes in
 */
// eslint-disable-next-line complexity
function normalizeIconName(name) {
  switch (name) {
    case 'insta-2':
    case 'notifications':
    case 'over-app':
    case 'studio':
    case 'vector1':
    case 'package':
    case 'box':
      return 'none';
    case 'add-page':
      return 'add';
    case 'alarm2':
      return 'bell';
    case 'badge':
      return 'user';
    case 'bag1':
    case 'bag2':
    case 'bag3':
    case 'bag4':
    case 'bag5':
    case 'bag6':
      return 'bag';
    case 'bullets':
      return 'bulleted-list';
    case 'cart-v2':
      return 'cart';
    case 'check-box':
      return 'checkbox';
    case 'chevron-dbl-left-lt':
      return 'chevron-dbl-left';
    case 'chevron-dbl-right-lt':
      return 'chevron-dbl-right';
    case 'chevron-down-lt':
      return 'chevron-down';
    case 'chevron-up-lt':
      return 'chevron-up';
    case 'creditCard':
      return 'credit-card';
    case 'delete-fill':
      return 'delete';
    case 'dropdown':
      return 'dropdown-menu';
    case 'ellipses':
      return 'ellipsis';
    case 'eye':
      return 'show';
    case 'eye-close':
      return 'hide';
    case 'facebook-box':
      return 'facebook';
    case 'file':
      return 'page';
    case 'google-box':
    case 'google-plus-box':
      return 'google';
    case 'google_shopping':
      return 'google-shopping';
    case 'heart-fill':
      return 'heart';
    case 'img-gallery':
      return 'image-gallery';
    case 'italics':
      return 'italic';
    case 'linkedin-box':
      return 'linkedin';
    case 'magnifying-glass':
      return 'search';
    case 'lightning':
      return 'lightning-bolt';
    case 'like':
      return 'thumbs-up';
    case 'magic':
      return 'wand';
    case 'paperclip':
      return 'attachment';
    case 'receipt2':
      return 'receipt';
    case 'select3':
      return 'select';
    case 'star-outline':
      return 'star';
    case 'twitter-box':
      return 'twitter';
    case 'tag-end':
      return 'code';
    case 'tools':
      return 'apps2';
    case 'window':
      return 'window-new';
    case 'wrench':
      return 'settings1';
    case 'windowsserver':
      return 'windows';
    case 'youtube-box':
      // the present set does not support without the -box on it
      return 'youtube';
    default:
      return name?.toLowerCase().replace(/\s+/g, '-');
  }
}